import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { AnalysisService } from '@app/services/entities/analysis.service';
import { MatDialog } from '@angular/material/dialog';
import { AnalysisDetailDialogComponent } from '../analysis-detail-dialog/analysis-detail-dialog.component';
import { AnalysisJobDetail } from '@app/types';

@Component({
  selector: 'app-analysis-status-card',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatProgressBarModule, MatTooltipModule, MatButtonModule],
  templateUrl: './analysis-status-card.component.html',
  styleUrls: ['./analysis-status-card.component.scss']
})
export class AnalysisStatusCardComponent {
  private analysisService = inject(AnalysisService);
  private dialog = inject(MatDialog);

  state = this.analysisService.state;
  elapsedTime = this.analysisService.elapsedTime;

  formatTime(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}s`;
  }

  openDetails(job: AnalysisJobDetail) {
    this.dialog.open(AnalysisDetailDialogComponent, {
      width: '800px',
      data: job
    });
  }

  pause() {
    this.analysisService.pauseAnalysis().subscribe();
  }

  resume() {
    this.analysisService.startFullAnalysis().subscribe();
  }

  purge() {
    if (confirm("¿Estás seguro o de vaciar la cola? Los documentos pendientes no se procesarán.")) {
      this.analysisService.purgeQueue().subscribe();
    }
  }
}